import { LessonType } from "@onair/repositories";

export const getResourceFileIcon = (
	mimeType: string | null,
	thumbnailUrl: string | null,
) => {
	const fileType = mimeType?.split("/")?.[0] || "";
	if (mimeType && ["image", "video"].includes(fileType)) {
		if (thumbnailUrl) return thumbnailUrl;

		return fileType === "image"
			? "/assets/icons/files/ic-img.svg"
			: "/assets/icons/online-course/ic-video.svg";
	}

	const fileSubType = mimeType?.split("/").pop()?.toLowerCase();
	switch (fileSubType) {
		case "pdf":
			return "/assets/icons/files/ic-pdf.svg";
		case "vnd.openxmlformats-officedocument.wordprocessingml.document":
		case "msword":
			return "/assets/icons/files/ic-word.svg";
		case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
		case "vnd.ms-excel":
			return "/assets/icons/files/ic-excel.svg";
		case "vnd.openxmlformats-officedocument.presentationml.presentation":
		case "vnd.ms-powerpoint":
			return "/assets/icons/files/ic-power_point.svg";
		default:
			return "/assets/icons/files/ic-excel.svg";
	}
};
